import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";

import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

import PopUpGalaxyResults from "../../agent/components/popup-galaxy-results";
import PopUpTPResults from "../../agent/components/popup-tp-results";
import PopUpBetfairResults from "../../agent/components/popup-betfair-results";

export default function ClientBetDetailsPopup() {
  const { transid } = useParams();
  const [data, setData] = useState(null);
  const [summarydata, setSummaryData] = useState(null);
  const [Dealer, setDealer] = useState("");
  const [win_amount, setWinAmount] = useState(0);
  const [resultsData, setResultsData] = useState(null);
  const [betSummary, setBetSummary] = useState({});
  const [catMid, setCatMid] = useState("");
  const [marketType, setMarketType] = useState("");
  const [gameType, setGameType] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = false;

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(
        `profit-loss/trans-details/${transid}`
      );
      let winAmount = response?.data.winAmount;
      let comission = response?.data.comission;

      //let result = response?.data.bet.result;
      setWinAmount(winAmount);
      debugger;
      //setResultsData(result);
      //setResultsData(response.data.bet);
      setResultsData(response.data.bet.rateJson);

      // let resultVal = resultsData?.result;

      if (comission > 0) {
        let obj = {};
        obj.rnr = "Commission";
        obj.rnrsid = "Commission";
        obj.amnt = 1;
        obj.result_status = "";
        obj.cashout_rate = 0 - comission;
        obj.rate = 1;
        obj.pro = comission;
        obj.type = "c";
        obj.lib = 0 - comission;
        obj.stmp = 0 - comission;
        obj.displayTxt = "Commission";
        obj.id = "00000000-0000-0000-0000-000000000000";
        obj.uname = "";
        obj.Dealer = "";

        response.data?.bet?.betList?.push(obj);
      }

      setSummaryData(response.data.bet);
      setBetSummary(response?.data?.bet?.bet_summary[0]);

      setData(response.data.bet.betList);
      //setResultsData(response.data.bet.rateJson);
      setCatMid(response.data.bet.cat_mid);
      setDealer(response.data.bet.dealer);
      setIsLoading(false);
      setMarketType(response?.data?.bet?.market_type);
      setGameType(response?.data?.bet?.game_type);

      //setWinAmount(response.data.bet.win_amount);
      console.log(response.data);
      console.log("response:", response.data.bet);
      console.log("BET LIST ", response.data.bet.betList);
      console.log("DATA PASSED TO TABLE", data);
    };
    fetchBetDetails();
  }, []);

  const getType = (data) => {
    if (data == "c") {
      return `<strong>C</strong>`;
    } else {
      if (data == "L" || data == "l") {
        return `<strong>L</strong>`;
      } else if (data == "N" || data == "n") {
        return `<strong>N</strong>`;
      } else if (data == "Y" || data == "y") {
        return `<strong>Y</strong>`;
      } else {
        return `<strong>B</strong>`;
      }
    }

    //return `<strong>${data}</strong>`;
  };

  let winnerName = "";

  const toCamelCase = (str) => {
    return str
      .toLowerCase()
      .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""));
  };

  const toPascalCase = (str) => {
    const camel = toCamelCase(str);
    return camel.charAt(0).toUpperCase() + camel.slice(1);
  };

  const cols = useMemo(
    () => [
      {
        title: "Runner",
        data: "rnrsid",
        responsivePriority: 1,
        render: (d, type, row, meta) => {
          let runnerName = "";
          if (marketType == 1 || marketType == 2) {
            runnerName = row.section;
          } else if (marketType == 3) {
            runnerName = row.section;
          } else if (marketType == 47 || marketType == 49 || marketType == 50) {
            runnerName = row.rnr;
          } else if (marketType == 48) {
            if (row.rnr == "b1") {
              runnerName = "Andar";
            } else {
              runnerName = "Bahar";
            }
          } else if (marketType == 51) {
            runnerName = row.rnrname;
          } else {
            runnerName = row.section;
          }

          runnerName = row.displayTxt;

          return `
          <div class="d-flex align-items-center justify-content-between"> 
            <span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${runnerName}</span>
          </div>`;
        }
      },
      {
        title: "Price",
        data: "amnt",
        render: (d) => (d != null ? formatTruncate(d) : "")
      },
      {
        title: "Size",
        data: "rate",
        render: (d) => (d != null ? d : "")
      },
      {
        title: "Side",
        data: "type",
        createdCell: (td, val) => {
          if (val == "c") {
            $(td).css({
              background: "#d03341",
              color: "black",
              textAlign: "left",
              fontWeight: "400",
              fontSize: "0.9rem"
            });
          } else {
            if (val === "L" || val === "l" || val === "n" || val === "N") {
              $(td).css({
                background: "#dc3545",
                color: "black",
                textAlign: "left",
                fontWeight: "400",
                fontSize: "0.9rem"
              });
            } else {
              $(td).css({
                background: "#179aaf",
                color: "black",
                textAlign: "left",
                fontWeight: "400",
                fontSize: "0.9rem"
              });
            }
          }
        },
        render: (d) => getType(d)
      },
      {
        title: "P/L",
        data: "lib",
        /*createdCell: (td, cellData, rowData) => {
          const val = rowData.type === "L" ? rowData.lib : rowData.pro;
          if (val < 0) {
            $(td).css({
              background: "#f8d7da",
              color: "#842029",
              fontWeight: 600,
              textAlign: "right"
            });
          } else {
            $(td).css({
              background: "#d1e7dd",
              color: "#0f5132",
              fontWeight: 600,
              textAlign: "right"
            });
          }
        },*/
        render: (d, type, row) => {
          let val = 0;

          if (row.type == "c") {
            val = row.lib;
            return `<span style="white-space: nowrap;font-size: 0.9rem;color:red" class="txt_css">${formatTruncate(
              val
            )}</span>`;
          } else {
            if (row.rnr == "Commission" || row.rnrname == "Commission") {
              val = row.lib;
            } else {
              val =
                row.type.toUpperCase() === "L"
                  ? Math.round(row.lib)
                  : Math.round(row.pro);
            }

            return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${formatTruncate(
              val
            )}</span>`;
          }

          //return `<span  class="txt_css">${formatTruncate(val)}</span>`;
        }
      },
      {
        title: "Placed At",
        data: "stmp",
        /*render: (d) =>
          `<span  class="txt_css">${moment(d).format(
            "YYYY-MM-DD HH:mm:ss"
          )}</span>`*/

        render: (d) =>
          `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            d
          ).format("MM/DD/YYYY HH:mm:ss a")}</span>`
      },
      {
        title: "Settled At",
        data: null,
        render: () => {
          return `<span style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${moment(
            summarydata?.created_date
          ).format("MM/DD/YYYY HH:mm:ss a")}</span>`;
        }
      },
      {
        title: "Order Id",
        data: "id",
        //render: (d) => `<strong  class="txt_css">${d ?? ""}</strong>`
        render: (d) =>
          `<strong style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">${
            d ?? ""
          }</strong>`
      },
      /*{
        title: "Customer",
        data: null,
        render: () => `<strong>${summarydata?.uname ?? ""}</strong>`
      },
       {
        title: "Dealer",
        data: null,
        render: () => `<strong>${Dealer ?? ""}</strong>`
      },
      {
        title: "FullOdds",
        data: null,
        render: () => `
      <strong style="white-space: nowrap;font-size: 0.9rem;" class="txt_css">
        <span>440</span>@<span style="color:blue">1.02</span> -
        <span>5070</span>@<span style="color:blue">1.01</span> =
        <span>1567</span>@<span style="color:red">1.03</span> -
        <span>3476</span>@<span style="color:red">1.04</span> -
        <span>2757</span>@<span style="color:red">1.05</span>
      </strong>
    `
      },*/
      {
        title: "",
        data: "pro",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 3
      },
      {
        title: "",
        data: "_id",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 6
      },

      {
        title: "",
        data: "section",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 4
      },
      {
        title: "",
        data: "fullodds",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 5
      },
      {
        title: "",
        data: "game_type",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 6
      },
      {
        title: "",
        data: "is_loss",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 7
      },

      {
        title: "",
        data: "rnr",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 8
      },
      {
        title: "",
        data: "rnrname",
        visible: false,
        render: (d) => `<span class="txt_css">${d}</span>`,
        responsivePriority: 9
      },
      {
        title: "",
        data: "displayTxt",
        visible: false
      }
    ],
    [summarydata]
  );

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !data.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe data (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (data || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: {
          details: {
            type: "column",
            target: 0
          }
        },

        pageLength: pageSize || 10,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        paging: true,
        order: initialOrder,
        columnDefs: [
          {
            className: "dtr-control",
            orderable: false,
            targets: 0
          },
          {
            responsivePriority: 10000,
            targets: "_all"
          }
        ],
        //dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',
        dom: '<"dt-search"f>' + "rt" + "<'row'<'col-sm-5'i><'col-sm-7'p>>",
        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f2f2f2", // dark row background
              color: "" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);

        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // Using the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, data, pageSize, defaultExpand, isLoading]);

  const getMarketType = (market_type) => {
    let txt = "";
    if (market_type == 1) {
      txt = " /Match Odd";
    } else if (market_type == 2) {
      txt = " /Bookmaker";
    } else if (market_type == 5) {
      txt = " /Tie";
    }

    return txt;
  };

  return (
    <>
      <div className="animated fadeIn" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card site_family">
                <div className="card-header">
                  <h5 className="m-0 d-flex align-items-center">
                    <span
                      style={{ paddingLeft: 10, fontSize: 20 }}
                      className="heading_css"
                    >
                      {summarydata?.event_name}
                      {getMarketType(summarydata?.market_type)}
                    </span>
                  </h5>
                </div>

                <div className="card-body">
                  <div class="row mb-3">
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Winner
                      <span class="badge badge-warning ml-2">
                        {" "}
                        {/*{resultsData}*/}
                        {summarydata?.game_type === 4 ||
                        summarydata?.game_type === 5 ? (
                          <span>{summarydata?.result}</span>
                        ) : (
                          summarydata?.result
                        )}
                      </span>
                    </div>

                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Net PL
                      <span
                        id="win_amt"
                        className={
                          win_amount < 0
                            ? "badge badge-danger bg-danger ml-2"
                            : "badge badge-success bg-success ml-2"
                        }
                        style={{
                          fontSize: "100%",
                          color: "white",
                          padding: 4,
                          borderRadius: 4,
                          fontSize: "0.8rem"
                        }}
                      >
                        {formatTruncate(win_amount)}
                      </span>
                    </div>
                    <div
                      class="col-4 col-md-4 txt_css"
                      style={{ fontSize: "1rem" }}
                    >
                      Username
                      <span class="ml-2 badge badge-warning">
                        {" "}
                        {summarydata?.uname}
                      </span>
                    </div>
                  </div>

                  <div className="datatable-wrapper">
                    <table
                      ref={gridTableRef}
                      className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2 txt_css"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th key={String(c.data || c.title)}>{c.title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
              </div>

              {gameType === 10 && (
                <PopUpGalaxyResults
                  resultsData={resultsData}
                  catMid={catMid}
                  marketType={marketType}
                />
              )}
              {gameType === 7 && (
                <PopUpTPResults
                  resultsData={resultsData}
                  catMid={catMid}
                  marketType={marketType}
                />
              )}
              {gameType !== 10 && gameType !== 7 && (
                <PopUpBetfairResults
                  resultsData={resultsData}
                  catMid={catMid}
                  marketType={marketType}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <style>{`

table.dataTable.no-footer {
  border-bottom: 0px solid #111;
}
.table.dataTable thead th, table.dataTable thead td{
  border-bottom: 1px solid #dee2e6;
}
.dt-paging-button { 
  padding: .5em 0px; 
}

        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 4px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        
        .pagination {
          
          float: right;
      }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#337ab7;
          display:flex;
          align-items:center;
          justify-content:center;
          font-family: 'Courier New', Courier, monospace;
          border: 2px solid white;
          box-shadow: 0 0 3px #444;
           
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .pagination {
          
            float: unset;
        }
        .dt-info {
          float: unset;
          
      }
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
        .heading_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          margin-bottom: .5rem;
          line-height: 1.2;
          font-size: 1.5rem;
          font-weight: 500;
          padding: .75rem 1.25rem;
         
        }

        .txt_css {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
        }



        table.dataTable.dtr-inline.collapsed tbody tr td.dtr-control:before,
        table.dataTable.dtr-inline.collapsed tbody tr th.dtr-control:before 
        {
          height: 14px;
    width: 14px;
    margin-right: .5em;
    display: inline-block;
    content: "+";
    color: white;
    border: 2px solid white;
    border-radius: 14px;
    box-shadow: 0 0 3px #444;
    box-sizing: content-box;
    text-align: center;
    text-indent: 0 !important;
    font-family: 'Courier New', Courier, monospace;
    line-height: 14px;
    background-color: #337ab7;
    float: inline-start; 
        }

        div.dt-container .dt-paging .dt-paging-button {
          padding: 4px 0px;
        }

        div.dt-container .dt-paging .dt-paging-button:hover {
          /* color: white !important; */
          border: 0px solid #111;
          background-color: transparent
          background: unset;
      }

/* Open row */
table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > td.dtr-control:before, table.dataTable.dtr-inline.collapsed > tbody > tr.dtr-expanded > th.dtr-control:before {
  content: '-';
  background-color: #d33333;
  border: 2px solid white;
  float: inline-start;
}
      `}</style>
    </>
  );
}
